/**
 * @fileoverview Note-tag relationship data source and type definitions.
 */

import { NoteTagSchema, type NoteTag } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAuditFields, createIdField, createJsonField, createSelectField, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';
import { createOptionLoader } from './option-loader';

export type { NoteTag };

const noteLoader = createOptionLoader('note', 'title');
const tagLoader = createOptionLoader('tag');

export const noteTagDataSource = createBaseDataSource<NoteTag>({
  endpoint: 'note_tag',
  searchField: 'note_id',
  schema: NoteTagSchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createSelectField('note_id', 'Note', noteLoader.getOptions(), FIELD_WIDTHS.MEDIUM),
    createSelectField('tag_id', 'Tag', tagLoader.getOptions(), FIELD_WIDTHS.MEDIUM),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAuditFields(),
  ],
});

export const noteTagCache = getCache('note_tag');
